<fieldset class="u-fade-slide-in">
  <header>
    <h4>{{ 'media_block.header' | translate }}</h4>
    @if (
      contentType() === 'scenic' || contentType() === 'gps-only' || contentType() === 'coaching'
    ) {
      <button (click)="openFullscreenModal()">
        <kin-icon name="full_screen" />
      </button>
    }
  </header>

  @if (contentType() === 'workout' && workoutForm(); as workoutForm) {
    <app-input-radio-element
      [elementsList]="workoutSourceItemList"
      [selectedValue]="createContentService.workoutSource()"
      (valueChange)="createContentService.workoutSource.set($event)"
    />
    @if (createContentService.workoutSource() === 'import') {
      <app-workout-uploader [workoutForm]="workoutForm" />
    }
  } @else if (mediaForm(); as mediaForm) {
    <div class="inputs-container">
      @if (contentType() === 'scenic' || contentType() === 'coaching') {
        <app-video-uploader [mediaForm]="mediaForm" [contentType]="contentType()" />
      }
      @if (contentType() === 'scenic' || contentType() === 'gps-only') {
        <app-gps-uploader [contentType]="contentType()" [mediaForm]="mediaForm" />
      }
    </div>
  }

  @if (mediaBlockService.hasVideoAndGps()) {
    <app-syncro-status mode="inline" (openEditor)="openFullscreenModal()" />

    <app-syncro-editor />
  }
</fieldset>
